export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";